import type { FaireProductEntity } from "../../entity_types/product";

export const p_kuzsrmmmzf: FaireProductEntity = {
  token: "p_kuzsrmmmzf",
  type: "product",
  name: "High Ball Glasses, Colorblock",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/a11154f34684347970b5293c004be1c8bfb6e11e5aa6f9253a6f7317054e593c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1fe0019ffe252c4e49ce09ab845b3da3b59d1ba48804f7d571ced9ad5eaa134f.jpeg",
    "https://cdn.faire.com/fastly/b9f8c3fc68cc3cd2437e7fa7bd5f397b3ab7a05ac04734e4769d0869c1a1aabd.jpeg",
    "https://cdn.faire.com/fastly/499249f602d6abbe9dbf89b144acb48f0bc3dd3270cd3dfaca5a2fea17dd7415.jpeg"
  ],
  priceDollars: 17,
  description: "Great for homemade cocktails or for sprucing up your daily water intake, these ban.do highball glasses bring instant color and joy to any table. With their super colorful design and modern shape, they’re the perfect party guests—always a hit and never out of style.\n\n𝗙𝗲𝗮𝘁𝘂𝗿𝗲𝘀:\n\n• Set of 2 highball glasses with vibrant, colorful designs\n• Made of durable, high-quality glass\n• Perfect for cocktails, mocktails, or everyday drinks\n• Adds a playful pop of color to any kitchen or bar setup\n• Designed in ban.do’s signature fun and optimistic style\n\n𝗜𝗱𝗲𝗮𝗹 𝗙𝗼𝗿:\n\n• Gift shops and home décor boutiques\n• Lifestyle retailers and kitchenware stores\n• Party hosts, cocktail lovers, and home entertainers\n• Wholesale buyers seeking stylish, joyful glassware",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:18.123Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
